import { SVGProps } from 'react'

export const Resources = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      d="M1.83333 4.11111H1V5.77778H1.83333V4.11111ZM1.83333 18H1V19.6667H1.83333V18ZM21.2778 5.77778H22.1111V4.11111H21.2778V5.77778ZM10.1667 19.6667H11V18H10.1667V19.6667ZM19.3333 6.61111V7.44444H21V6.61111H19.3333ZM12.3889 3.83333V3H10.7222V3.83333H12.3889ZM14.0556 22.1667L13.2258 22.0893L13.1409 23H14.0556V22.1667ZM23.5 22.1667V23H24.4147L24.3298 22.0893L23.5 22.1667ZM2.94444 5.77778H11.5556V4.11111H2.94444V5.77778ZM11.5556 5.77778H20.1667V4.11111H11.5556V5.77778ZM3.77778 18.8333V4.94444H2.11111V18.8333H3.77778ZM2.94444 4.11111H1.83333V5.77778H2.94444V4.11111ZM2.94444 18H1.83333V19.6667H2.94444V18ZM20.1667 5.77778H21.2778V4.11111H20.1667V5.77778ZM10.1667 18H2.94444V19.6667H10.1667V18ZM19.3333 4.94444V6.61111H21V4.94444H19.3333ZM12.3889 4.94444V3.83333H10.7222V4.94444H12.3889ZM14.8853 22.244C15.0823 20.1306 16.6182 18.5556 18.7778 18.5556V16.8889C15.6608 16.8889 13.4934 19.2192 13.2258 22.0893L14.8853 22.244ZM18.7778 18.5556C20.9373 18.5556 22.4732 20.1306 22.6702 22.244L24.3298 22.0893C24.0621 19.2192 21.8948 16.8889 18.7778 16.8889V18.5556ZM14.0556 23H23.5V21.3333H14.0556V23ZM20.4444 13C20.4444 13.9204 19.6982 14.6667 18.7778 14.6667V16.3333C20.6188 16.3333 22.1111 14.841 22.1111 13H20.4444ZM18.7778 14.6667C17.8573 14.6667 17.1111 13.9204 17.1111 13H15.4444C15.4444 14.841 16.9368 16.3333 18.7778 16.3333V14.6667ZM17.1111 13C17.1111 12.0796 17.8573 11.3333 18.7778 11.3333V9.66667C16.9368 9.66667 15.4444 11.159 15.4444 13H17.1111ZM18.7778 11.3333C19.6982 11.3333 20.4444 12.0796 20.4444 13H22.1111C22.1111 11.159 20.6188 9.66667 18.7778 9.66667V11.3333Z"
      fill="currentColor"
    />
  </svg>
)

